module.exports = __webpack_public_path__ + "static/media/cameraIcon.9d36adcb.svg";